export enum RolTypeEnum {
  IS_FOLDER = 0,
  IS_RESPONSIBLE = 1
}
